import { TFunction } from 'i18next';
import { z } from 'zod';

import {
  fileValidationSchema,
  getOptionalNumberValidationSchema,
  getOptionalStringValidationSchema,
  getStringValidationSchema,
} from '@/shared/lib/validations';

import { PackageBookingSchema, SpaceBookingSchema } from './formMappers';

export const makeMediaPlanFormSchema = (t: TFunction) =>
  z.object({
    request: z.object({
      companyId: getOptionalStringValidationSchema(),
      planName: getStringValidationSchema({ t, min: 1 }).max(120, t('plan_name_max_length')),
      clientId: getOptionalStringValidationSchema(),
      brands: getStringValidationSchema({ t }).array(),
      budget: getOptionalNumberValidationSchema().refine(
        (val) => val === undefined || val === null || val === '' || val <= 1000000,
        {
          message: t('budget_max_value'),
        },
      ),
      startDate: getStringValidationSchema({ t }),
      endDate: getStringValidationSchema({ t }),
      filters: z.record(z.string(), z.any()).optional(),
      bookings: SpaceBookingSchema.array(),
      packageBookings: PackageBookingSchema.array(),
    }),
    keyVisuals: fileValidationSchema().optional(),
  });
